import { IOfferModeWithFSecure } from "@nju/data-access-portal-offers";
import {
  IFSecureOrchestrator,
  IFtthOrchestrator,
  IMobileOrchestrator,
  IMultiOrderOrchestrator,
} from "@nju/data-access-portal-orchestrator";

interface IResolveOrchestratorProps {
  mode: IOfferModeWithFSecure;
  ftth: IFtthOrchestrator | undefined;
  mobile: IMultiOrderOrchestrator | IMobileOrchestrator | undefined;
  fsecure: IFSecureOrchestrator | undefined;
}

export function resolveOrchestrator({
  mode,
  ftth,
  mobile,
  fsecure,
}: IResolveOrchestratorProps) {
  if (mode === "ftth") {
    return ftth;
  }

  if (["mobile", "postpaid"].includes(mode)) {
    return mobile;
  }

  if (mode === "fsecure") {
    return fsecure;
  }

  return;
}
